import { createSlice } from '@reduxjs/toolkit'
import { LANGUAGE_CODES } from '../../constants/languageList'
import { getItem, setItem } from 'utils/storageUtils'
import { mergeLanguageData } from 'utils/language'

const userLang = navigator.language.toUpperCase().substring(0, 2) || navigator.userLanguage.toUpperCase().substring(0, 2)
const getInitialLanguageCode = () => {
  const savedLang = getItem('language')
  if (savedLang && LANGUAGE_CODES?.[savedLang.toUpperCase()]) {
    return savedLang.toUpperCase()
  }

  const pathLang = window?.location?.pathname?.split('/')?.[1]
  if (pathLang && LANGUAGE_CODES?.[pathLang.toUpperCase()]) {
    setItem('language', pathLang?.toUpperCase())
    return pathLang.toUpperCase()
  }

  if (LANGUAGE_CODES?.[userLang]) {
    setItem('language', userLang?.toUpperCase())
    return userLang.toUpperCase()
  }

  setItem('language', process.env.REACT_APP_DEFAULT_LANGUAGE)
  return process.env.REACT_APP_DEFAULT_LANGUAGE
}

const {
  actions: {
    getLanguagesStart,
    getLanguagesSuccess,
    getLanguagesFailure,
    setSelectedLanguagesStart,
    setSelectedLanguagesComplete,
    getLanguageDataStart,
    getLanguageDataSuccess,
    getLicenseDetailSuccess,
    getLanguageDataFailure,
    updateUserLangSuccess,
    setUserCountry,
    setBrandLogo,
    getChatProviderSuccess,
    setPhoneVerificationType
  },
  reducer
} = createSlice({
  name: 'language',
  initialState: {
    loading: false,
    selectedLanguageCode: getInitialLanguageCode(),
    showUserLang: true,
    userIPCountry: null,
    brandLogo: null,
    licenseDetail: {},
    chatProvider: null,
    phoneVerificationType: null
  },
  reducers: {
    getLanguagesStart: (state) => ({
      ...state,
      loading: true
    }),
    getLanguagesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      languages: payload
    }),
    getLanguagesFailure: (state) => ({
      ...state,
      loading: false
    }),
    setSelectedLanguagesStart: (state) => ({
      ...state,
      loading: true,
      languageChanged: true
    }),
    setSelectedLanguagesComplete: (state, { payload }) => ({
      ...state,
      loading: false,
      selectedLanguageCode: payload?.selectedLanguageCode,
      languageChanged: false
    }),
    getLanguageDataStart: (state) => ({
      ...state,
      loading: true
    }),
    getLanguageDataSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      languageData: mergeLanguageData(state.languageData, payload)
    }),
    getLicenseDetailSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      licenseDetail: payload
    }),
    getLanguageDataFailure: (state) => ({
      ...state,
      loading: false
    }),
    updateUserLangSuccess: (state) => ({
      ...state,
      showUserLang: false
    }),
    setUserCountry: (state, { payload }) => ({
      ...state,
      userIPCountry: payload
    }),
    setBrandLogo: (state, { payload }) => ({
      ...state,
      brandLogo: payload
    }),
    getChatProviderSuccess: (state, { payload }) => ({
      ...state,
      chatProvider: payload
    }),
    setPhoneVerificationType: (state, { payload }) => ({
      ...state,
      phoneVerificationType: payload
    })
  }
})

export default reducer

export {
  getLanguagesStart,
  getLanguagesSuccess,
  getLanguagesFailure,
  setSelectedLanguagesStart,
  setSelectedLanguagesComplete,
  getLanguageDataStart,
  getLanguageDataSuccess,
  getLicenseDetailSuccess,
  getLanguageDataFailure,
  updateUserLangSuccess,
  setUserCountry,
  setBrandLogo,
  getChatProviderSuccess,
  setPhoneVerificationType
}
